import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { compose, mapProps } from 'recompose';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';
import styled from 'styled-components';

import { Text, Box, Flex, Icon, ICON_LIST } from 'Components/Base';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import { AdaptiveQuizExporter } from 'Containers/AdaptiveQuizExporter';
import AdaptiveQuiz from 'Containers/AdaptiveQuiz';
import { getAdaptiveQuizFilterValue } from 'Containers/AdaptiveQuiz/utils';
import { getUpdateTime } from 'Domains/adaptiveQuiz';
import { getSchoolCode } from 'Domains/LESchoolData/Routing';
import { useAnalytics } from 'Libs/Analytics';

const AdaptiveQuizPageWrapper = styled(Box)`
  border-radius: 10px;
  flex: 1 0;
  display: grid;
  grid: auto auto 1fr / 100%;
  row-gap: 16px;
`;

const AdaptiveQuizPage = ({ schoolCode, onLogAction, auth: { myProfile } }) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('adaptiveQuiz');
  const location = useLocation();
  const [isFetchData, setIsFetchData] = useState(false);
  const [disabledFetch, setDisabledFetch] = useState(true);

  return (
    <AdaptiveQuizPageWrapper px={[0, null, 2, 7]} py={[0, null, 3, 5]} bg={'white'}>
      <Box>
        <Flex alignItems={'center'} justifyContent={'space-between'}>
          <Text.Title>{t('TITLE')}</Text.Title>
          <Flex>
            <AdaptiveQuizExporter
              disabled={disabledFetch}
              filterValue={getAdaptiveQuizFilterValue(new URLSearchParams(location.search))}
              schoolCode={schoolCode}
              myProfileId={myProfile.id}
            />
            <ButtonOutlinedIcon
              textProp={{
                fontWeight: 'semibold',
              }}
              ml={2}
              lineHeight={'0.5'}
              height={'40px'}
              leftIcon={<Icon name={ICON_LIST.REFRESH} />}
              message={t('UPDATE')}
              disabled={disabledFetch}
              onClick={() => {
                onLogAction({
                  category: 'Fatch data',
                  action: `Click`,
                  label: `Click on adaptive quiz page`,
                });
                send('update', { on: 'adaptive_quiz_page' });
                setIsFetchData(true);
              }}
            />
          </Flex>
        </Flex>
        <Flex justifyContent={'flex-end'} height={'16px'}>
          <Text.Hint
            mt={1}
            color={'timeUpdate'}
            textAlign={'right'}
            display={disabledFetch ? 'none' : 'block'}
          >
            {t('UPDATE_DESCRIPTION_TIME')} {getUpdateTime()}
          </Text.Hint>
        </Flex>
      </Box>

      <AdaptiveQuiz
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
        setDisabledFetch={setDisabledFetch}
        schoolCode={schoolCode}
        myProfileId={myProfile.id}
      />
    </AdaptiveQuizPageWrapper>
  );
};

export default compose(mapProps(getSchoolCode), withAnalytic)(AdaptiveQuizPage);
